import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_GIFT } from './router';

menuRegistry.registerMenu([
    {
        parent: 'Multiplayer',
        key: 'Gift',
        name: 'Gift',
        icon: 'fas fa-gift'
    },
    {
        parent: 'Multiplayer.Gift',
        key: 'Lucky',
        name: 'Lucky',
        icon: 'fas fa-leaf',
        route: { name: ROUTE_NAME_GIFT.LUCKY }
    },
    {
        parent: 'Multiplayer.Gift',
        key: 'Setting',
        name: 'Setting',
        icon: 'fas fa-cog',
        route: { name: ROUTE_NAME_GIFT.SETTING }
    }
]);

export default registerRouteForModule(router);
